export const APP_SHELL_COMPACT_MAX_WIDTH_PX = 960;
